export default __webpack_public_path__ + "static/media/TravelBackpackHiking.ffeb5aed.jpg";